export default function(ctx) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<p class="utrecht-paragraph utrecht-form-field__label">\n  <label\n    class="utrecht-form-label utrecht-form-label--openforms ' +
((__t = (ctx.label.className)) == null ? '' : __t) +
' ';
 if (ctx.component.validate.required && ctx.requiredFieldsWithAsterisk) { ;
__p += 'utrecht-form-label--openforms-required';
 } ;
__p += '"\n    for="' +
((__t = (ctx.instance.id)) == null ? '' : __t) +
'-' +
((__t = (ctx.component.key)) == null ? '' : __t) +
'"\n    ';
 if (ctx.component.suffix) { ;
__p += '\n      id="label-' +
((__t = (ctx.instance.id)) == null ? '' : __t) +
'-' +
((__t = (ctx.component.key)) == null ? '' : __t) +
'"\n    ';
 } ;
__p += '\n  >\n    ' +
((__t = ( ctx.t(ctx.component.label, { _userInput: true }) )) == null ? '' : __t) +
'\n    ';
 if (!ctx.component.validate.required && !ctx.requiredFieldsWithAsterisk) { ;
__p += '\n      ' +
((__t = ( ctx.t('(not required)') )) == null ? '' : __t) +
'\n    ';
 } ;
__p += '\n    ';
 if (ctx.component.tooltip) { ;
__p += '\n      <i ref="tooltip" class="openforms-tooltip-icon ' +
((__t = (ctx.iconClass('question-sign'))) == null ? '' : __t) +
'" data-tooltip="' +
((__t = ( ctx.tooltip )) == null ? '' : __t) +
'"></i>\n    ';
 } ;
__p += '\n  </label>\n</p>\n';
return __p
}